<!--
  Program: Login page
  Author: SDL
  Brief: User login page
  2022/11/21
-->
<template>
  <div id="wrap" class="login">
    <!-- <GcrmHeader></GcrmHeader> -->
    <div id="container" >
      <div class="loginBox">
        <h1 class="logo">GCRM</h1>
        <p class="tit">
          Welcome to<label>GCRM Portal</label>
        </p>
        <p class="txt">Global Customer Relationship Marketing Portal</p>
        <div class="btn-area">
          <button type="button" class="btn btn-secondary btn-lg" @click="goToADRegist">AD {{$t('sdl.gcrm.common.signup')}}</button>
          <button type="button" class="btn btn-primary btn-lg" @click="loginByAd">{{$t('sdl.gcrm.common.signin')}}</button>
        </div>
        <div v-if="knockCnt > 4" class="afterEnter">
          <div class="input_box">
            <input
              type="text"
              id="inputID"
              class="form-control ui--login-id"
              placeholder="ID"
              required
              autofocus
              v-model="userId"
              @keydown.enter="handleSubmit()"
            />
            <label for="inputPassword" class="sr-only">Password </label>
            <input
              type="password"
              id="inputPassword"
              class="form-control ui--login-pass"
              placeholder="Password"
              required
              v-model="password"
            />
          </div>
          <div class="btn-area">
            <button type="button" class="btn btn-primary btn-lg" @click="handleSubmit()">Log in after<br>entering</button>
          </div>
        </div>
        <div class="f-logo"></div>
      </div>
    </div>
    <!-- <GcrmFooter></GcrmFooter> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SDLLocale from '@/mixin/SDLLocale';
import SDLUtil from '@/utils/SDLUtil';
import GcrmHeader from '@/components/view/admin/main/GcrmHeader';
import GcrmFooter from '@/components/view/admin/main/GcrmFooter';
import loginService from '@/service/loginService';
import { addEntryPoint, router } from '@/router';

export default {
  components: {
    GcrmHeader,
    GcrmFooter,
  },
  mixins: [SDLLocale],
  data() {
    return {
      title: SDLUtil.getMsgProp('sdl.common.projectName'),
      userId: 'munsu.jeong',
      password: '!QAZxsw23edc',
      rememberMe: false,
      submitted: false,
      roleList: [],
      isLoaderVisible: true,
      isIe: false,
      ADRegistUrl: 'https://corpadpss.secsso.net/PublicIDMS/NewAccount',
      knockCnt: 0,
    };
    //https://corpadpss.secsso.net/ADHelper   
    // ADRegistUrl: 'https://sarp.secsso.net/SARP/',
  },
  created() {
    if(SDLUtil.isMobile()){
      console.log('mobile browser - login');
      router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error?code=410` }).catch(() => {});
      // document.location.href=`${SDLUtil.WEB_CONTEXT_PATH}/error?code=410&redirect=${router.currentRoute.fullPath}`;
    } 
    if (this.$route.query.token) {
      // console.log('set token after ad login :: ', this.$route.query.token);
      // 토큰을 url에 물고왔을 경우. (AD인증인 경우)
      // 로컬스토리지에 토큰에 기반한 값을 다시 담고, main으로 보내자.
      // loginService.setToken(this.$route.query.token, this.gotoMain);
      loginService.setToken(this.$route.query.token);
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.token) {
        // console.log('set token after ad login :: ', this.$route.query.token);
        // 토큰을 url에 물고왔을 경우. (AD인증인 경우)
        // 로컬스토리지에 토큰에 기반한 값을 다시 담고, main으로 보내자.
        // loginService.setToken(this.$route.query.token, this.gotoMain);
        // loginService.setToken(this.$route.query.token);
        // this.gotoMain();
        const redirect = this.$route.query.redirect || '';
        // if (redirect && !redirect.includes('/error')) {
        if (redirect && !redirect.includes('/error') && !redirect.includes('http')) { // do not redirect to out.
          window.location.href = `${this.$context}${redirect}`;
        } else {
          window.location.href = `${this.$context}/`;
        }
      }
      // loginService.setToken(null, this.gotoMain);
    });
  },
  methods: {
    ...mapActions(['login', 'logout', 'loginEpTray']),
    async handleSubmit() {
      // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
      this.submitted = true;
      const { userId, password } = this;
      if (userId && password) {
        const loginResult = await this.login({ userId: this.userId, password: this.password });
        this.afterLoginProcess(loginResult);
      }
    },
    loginByAd() {
      // localStorage.setItem('user', '');
      // localStorage.setItem('userToken', '');
      const redirect = this.$route.query.redirect || '';
      // if (redirect) {
      if (redirect && !redirect.includes('http')) { // do not redirect to out.
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request?redirect=${redirect}`;
      } else {
        window.location.href = `${SDLUtil.API_URL}/noauth/saml-request`;
      }
    },
    // gotoMain() {
    //   const redirect = this.$route.query.redirect || '';
    //   if (redirect && !redirect.includes('/error')) {
    //     window.location.href = `${this.$context}/?redirect=${redirect}`;
    //   } else {
    //     window.location.href = `${this.$context}/`;
    //   }
    // },
    afterLoginProcess(loginResult) {
      if (loginResult) {
        if (this.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
          localStorage.setItem('rememberId', this.userId);
        } else {
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('rememberId');
        }
        const redirect = this.$route.query.redirect || '';
        // if (redirect) {
        if (redirect && !redirect.includes('http')) { // do not redirect to out.
          window.location.href = `${this.$context}${redirect}`;
        } else {
          window.location.href = `${this.$context}/`;
        }
      }
    },
    goToADRegist() {
      window.open(this.ADRegistUrl, '_blank');
    },
    knockknock() {
      this.knockCnt += 1;
    },
  },
};
</script>

<style lang="scss">
@import 'static/css/css.scss';
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/LoginPage.vue